var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "scrollbar-inner d-flex bg-secondary overflow-x" },
    [
      _c("div", { staticClass: "w-100 h-100" }, [
        _c(
          "div",
          {
            staticClass:
              "border-0 mb-0 shadow-none h-100 position-center pr bg-white overflow-scroll",
          },
          [
            _c(
              "button",
              {
                staticClass: "btn chat-close btn-close visible-xs",
                on: {
                  click: function ($event) {
                    return _vm.$emit("overlayClicked")
                  },
                },
              },
              [_c("i", { staticClass: "fa fa-times" })]
            ),
            _vm._t("default"),
          ],
          2
        ),
      ]),
      _c("div", {
        staticClass: "sidebar-overlay",
        on: {
          click: function ($event) {
            return _vm.$emit("overlayClicked")
          },
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }